export default __webpack_public_path__ + "static/14-dff8dd5d3f986b9f4e85cdf446aa6477.webp";